import { render, staticRenderFns } from "./BadgesModal.vue?vue&type=template&id=09646194&"
import script from "./BadgesModal.vue?vue&type=script&lang=js&"
export * from "./BadgesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports